import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.models": "ADU Models",
      "nav.packages": "ADU Packages",
      "nav.howItWorks": "How It Works",
      "nav.portfolio": "Portfolio",
      "nav.testimonials": "Testimonials",
      "nav.faq": "FAQ",
      "nav.getQuote": "Get Quote",
      "nav.login": "Login",

      // Hero
      "hero.title": "ALIGCUS  Build Your Dream ADU",
      "hero.subtitle": "Design · Permit · Build · Deliver  All-in-One Service",
      "hero.freeEstimate": "Free Estimate",
      "hero.browseModels": "Browse Models",

      // Stats
      "stats.number1": "#1",
      "stats.number1Sub": "30+ Years Builder Heritage",
      "stats.number1Desc": "",
      "stats.fiveStar": "1500+",
      "stats.fiveStarDesc": "ADUs Delivered",
      "stats.floorPlans": "",
      "stats.floorPlansSub": "Multiple Model Homes",
      "stats.floorPlansDesc": "Open for Touring",

      // Models Section
      "models.title": "We Build One to Multi-Bedroom ADUs",
      "models.subtitle": "Up to 1,200 sq. ft.   Massive Selection for Living & Investment",
      "models.learnMore": "Learn More",
      "models.getQuote": "Get Quote",
      "models.browseAll": "Browse All Floor Plans",
      "models.1bed": "1 Bedroom ADUs",
      "models.1bedDesc": "Perfect for single occupants or home office",
      "models.2bed1bath": "2 Bedroom ADUs",
      "models.2bed1bathDesc": "Ideal for small families or rental income",
      "models.2bed2bath": "2 Bed 2 Bath ADUs",
      "models.2bed2bathDesc": "Spacious living with full amenities",
      "models.2bed2bathDeluxe": "2 Bed 2 Bath Deluxe",
      "models.2bed2bathDeluxeDesc": "Enhanced layout with premium finishes",
      "models.3bed": "3 Bedroom ADUs",
      "models.3bedDesc": "Maximum space for families",
      "models.3bedPremium": "3 Bed Premium",
      "models.3bedPremiumDesc": "Our largest and most luxurious model",

      // ADU Packages Section
      "packages.title": "ADU PACKAGES",
      "packages.subtitle": "Compare our four standardized packages. All packages include quality construction with <1>JM Fiberglass</1> insulation, <2>Dunn Edwards</2> paint, and <3>Cooper</3> plumbing.",
      "packages.subtitlePlain": "Compare our four standardized packages. All packages include quality construction with JM Fiberglass insulation, Dunn Edwards paint, and Cooper plumbing.",
      "packages.viewFull": "View Full Package Comparison",
      "packages.popular": "POPULAR",
      "packages.standard": "Standard",
      "packages.standardDesc": "Quality construction with essential features",
      "packages.premium": "Premium",
      "packages.premiumDesc": "Upgraded materials and enhanced features",
      "packages.luxury": "Luxury",
      "packages.luxuryDesc": "High-end finishes and luxury amenities",
      "packages.smartLuxury": "Smart Luxury",
      "packages.smartLuxuryDesc": "Fully integrated smart home technology",
      "packages.perSqft": "/sqft",
      "packages.8ftCeiling": "8ft Ceiling",
      "packages.9ftCeiling": "9ft Ceiling",
      "packages.9ftVaulted": "9ft + Vaulted",
      "packages.miniSplit": "Mini Split AC",
      "packages.centralAC": "Central AC",
      "packages.smartHome": "Smart Home",
      "packages.standardFinishes": "Standard Finishes",
      "packages.premiumFinishes": "Premium Finishes",
      "packages.luxuryFinishes": "Luxury Finishes",
      "packages.premiumEverything": "Premium Everything",
      "packages.1yearWarranty": "1-Year Warranty",
      "packages.2yearWarranty": "2-Year Warranty",
      "packages.5yearWarranty": "5-Year Warranty",
      "packages.10yearWarranty": "10-Year Warranty",

      // How It Works
      "howItWorks.title": "How ALIGCUS Works",
      "howItWorks.subtitle": "A streamlined process from start to finish",
      "howItWorks.step1Title": "Free Estimate",
      "howItWorks.step1Desc": "Browse our products and request a free estimate from our team.",
      "howItWorks.step2Title": "Feasibility Study",
      "howItWorks.step2Desc": "Get an in-depth analysis of your property's needs and local regulations so you can move forward with confidence.",
      "howItWorks.step3Title": "Design & Permits",
      "howItWorks.step3Desc": "ALIGCUS helps you select the right layout and design elements for your property. Then we manage the entire permitting process.",
      "howItWorks.step4Title": "Construction & Delivery",
      "howItWorks.step4Desc": "Your ADU is built with precision craftsmanship. We prepare the foundation, deliver the unit, and get it ready for move-in day.",
      "howItWorks.getStarted": "Get Started with a Free Estimate",
      "howItWorks.learnMore": "Learn More About Our Process",

      // Turnkey Services
      "turnkey.title": "Our Turnkey Services",
      "turnkey.subtitle": "Comprehensive support from concept to completion",
      "turnkey.design": "Design & Planning",
      "turnkey.designDesc": "Expert architectural design tailored to your needs",
      "turnkey.projectManager": "Dedicated Project Manager",
      "turnkey.projectManagerDesc": "Your single point of contact throughout the process",
      "turnkey.feasibility": "Feasibility Study",
      "turnkey.feasibilityDesc": "Comprehensive property analysis and assessment",
      "turnkey.sitePrep": "Site Preparation",
      "turnkey.sitePrepDesc": "Professional groundwork and foundation services",
      "turnkey.permitting": "Permitting Services",
      "turnkey.permittingDesc": "Complete permit management and approval process",
      "turnkey.construction": "Expert Construction",
      "turnkey.constructionDesc": "High-quality construction with industry-leading standards",
      "turnkey.delivery": "Delivery & Installation",
      "turnkey.deliveryDesc": "Seamless delivery and professional installation",
      "turnkey.financing": "Financing Resources",
      "turnkey.financingDesc": "Connection to trusted financing partners",
      "turnkey.warranty": "Warranty Services",
      "turnkey.warrantyDesc": "Comprehensive warranty and ongoing support",

      // Portfolio
      "portfolio.title": "Every City Has Our ADU Story",
      "portfolio.subtitle": "Explore our portfolio of completed projects",
      "portfolio.featured": "Featured Project",
      "portfolio.featuredTitle": "Flexible Housing Solution",
      "portfolio.featuredSpec": "2 bed \u2022 2 bath \u2022 900 sq. ft.",
      "portfolio.featuredDesc": "A beautifully crafted ADU that maximizes space and functionality while maintaining aesthetic appeal. Perfect for rental income or extended family.",
      "portfolio.viewAll": "View All Featured Projects",

      // Comparison
      "comparison.title": "Pre-Approved vs Traditional Construction",
      "comparison.subtitle": "Our pre-approved plan sets and streamlined process significantly reduce permitting time and accelerate your ADU project",
      "comparison.feature": "Feature",
      "comparison.aligcus": "Pre-Approved",
      "comparison.traditional": "Traditional Stick-Built",
      "comparison.turnkey": "Turnkey process",
      "comparison.preApproved": "Multiple city government pre-approved plan sets",
      "comparison.expedited": "Expedited plan check and permit approval",
      "comparison.permittingTeam": "Dedicated permitting team",
      "comparison.floorPlans": "Pre-approved floor plans",
      "comparison.inspection": "Streamlined inspection process",
      "comparison.projectManager": "Dedicated project manager",
      "comparison.timeOnSite": "Time on-site",
      "comparison.aligcusTime": "~4-6 months",
      "comparison.traditionalTime": "~9-12+ months",
      "comparison.pricing": "Transparent, upfront pricing",
      "comparison.financing": "Financing partners available",
      "comparison.experience": "Experience the ALIGCUS difference",
      "comparison.cta": "Get Your Free Estimate Today",

      // FAQ
      "faq.title": "Frequently Asked Questions",
      "faq.subtitle": "Find answers to common questions about our ADU services",
      "faq.q1": "Can I visit an ADU model?",
      "faq.a1": "Yes! We welcome site visits to see our completed projects. Contact us at 626-803-8000 to schedule your visit.",
      "faq.q2": "What types of ADUs does ALIGCUS build?",
      "faq.a2": "ALIGCUS builds detached ADUs ranging from 500 to 1,200 square feet. These ADUs are not connected to the primary residence and are attached to their own permanent foundation. Our designs are pre-approved, meaning they have a streamlined permitting and inspection process.",
      "faq.q3": "How do I know if an ADU will fit on my property?",
      "faq.a3": "Reach out to our team at 626-803-8000 and we'll be happy to walk you through options in real time! We offer comprehensive feasibility studies to assess your property.",
      "faq.q4": "Do you offer financing options?",
      "faq.a4": "While we're not a lending institution, we can connect you with lenders that specialize in financing for ADUs. Contact us to learn more about our financing partners.",
      "faq.q5": "Are ALIGCUS ADUs customizable?",
      "faq.a5": "Yes! An ALIGCUS consultant will walk you through your customization options from our designer-approved finishes, materials, and layout modifications.",
      "faq.q6": "What types of floor plans are available?",
      "faq.a6": "We offer 1, 2, and 3-bedroom units ranging from 500 to 1,200 square feet. Each model can be customized to meet your specific needs and preferences.",
      "faq.q7": "Does ALIGCUS handle permits?",
      "faq.a7": "Yes, our expert team handles the entire permitting process! We have extensive experience working with local permitting offices throughout the Los Angeles area and have streamlined relationships that expedite the process.",
      "faq.q8": "How long does the construction process take?",
      "faq.a8": "Our streamlined process typically takes 4-6 months for on-site work, significantly faster than traditional stick-built construction which can take 9-12+ months. The total timeline from design to completion varies based on permitting and site conditions.",
      "faq.q9": "What is included in your turnkey service?",
      "faq.a9": "Our comprehensive turnkey service includes design and planning, feasibility study, permitting, site preparation, construction, delivery, installation, utility hookups, and warranty services. We handle everything from start to finish.",
      "faq.q10": "Can I use my ADU for rental income?",
      "faq.a10": "Yes! Many of our clients build ADUs specifically for rental income. ADUs are an excellent investment opportunity, and we can help you understand the potential ROI for your property.",
      "faq.stillQuestions": "Still have questions?",
      "faq.helpText": "Our team is here to help you every step of the way",
      "faq.contactUs": "Contact Us Today",

      // Testimonials
      "testimonials.title": "What Our Clients Say",
      "testimonials.subtitle": "Trusted by homeowners across Los Angeles",
      "testimonials.projects": "Projects Completed",
      "testimonials.satisfaction": "Client Satisfaction",
      "testimonials.rating": "Average Rating",

      // Footer
      "footer.description": "Comprehensive real estate company specializing in architecture, construction, and ADU development.",
      "footer.serving": "Proudly serving all of California",
      "footer.quickLinks": "Quick Links",
      "footer.socalOffice": "SoCal Office",
      "footer.norcalOffice": "NorCal Office",
      "footer.rights": "All rights reserved",
      "footer.privacy": "Privacy Policy",
      "footer.terms": "Terms of Service",
      "footer.cookies": "Cookie Policy",

      // Quote Calculator
      "quote.quickQuote": "QUICK QUOTE",
      "quote.getInstantEstimate": "Get an instant estimate for your ADU project.",
      "quote.projectAddress": "1. PROJECT ADDRESS",
      "quote.startTyping": "Start typing address...",
      "quote.satelliteView": "Property Location (Satellite View)",
      "quote.selectPackage": "2. SELECT PACKAGE",
      "quote.rooms": "3. ROOMS",
      "quote.bedrooms": "BEDROOMS",
      "quote.bathrooms": "BATHROOMS",
      "quote.squareFootage": "4. SQUARE FOOTAGE",
      "quote.size": "Size",
      "quote.recommendedFor": "Recommended for {{beds}} bed / {{baths}} bath: {{range}}",
      "quote.surchargeNote": "Below 800 sq.ft, each 100 sq.ft reduction adds $20/sq.ft (partial steps round up).",
      "quote.upgrades": "5. UPGRADES",
      "quote.optional": "(Optional)",
      "quote.addCustomItem": "Add Custom Item",
      "quote.itemName": "Item name",
      "quote.price": "Price",
      "quote.generateQuote": "GENERATE QUOTE",
      "quote.generating": "GENERATING...",
      "quote.estimatedTotal": "Estimated Total",
      "quote.enterInfo": "Enter address, select package & size to generate your quote",
      "quote.base": "Base",
      "quote.smallUnitSurcharge": "Small unit surcharge",
      "quote.upgradesLabel": "Upgrades",
      "quote.customItems": "Custom Items",
      "quote.backToHome": "Back to Home",

      // Quote Result
      "quoteResult.aduQuote": "ADU Quote",
      "quoteResult.projectLocation": "Project Location",
      "quoteResult.package": "Package",
      "quoteResult.sizeLabel": "Size",
      "quoteResult.layout": "Layout",
      "quoteResult.ceiling": "Ceiling",
      "quoteResult.priceSummary": "Price Summary",
      "quoteResult.totalEstimate": "Total Estimate",
      "quoteResult.notes": "Notes:",
      "quoteResult.note1": "Estimate only. Final price varies by site conditions.",
      "quoteResult.note2": "Excludes permit fees, utility connections, site prep.",
      "quoteResult.note3": "Valid for 30 days.",
      "quoteResult.specs": "Package Specifications",
      "quoteResult.downloadPdf": "Download PDF",
      "quoteResult.exporting": "Exporting...",
      "quoteResult.email": "Email",
      "quoteResult.print": "Print",
      "quoteResult.newQuote": "New Quote",
      "quoteResult.sendEmail": "Send Quote via Email",
      "quoteResult.yourName": "Your Name",
      "quoteResult.enterName": "Enter your name",
      "quoteResult.emailAddress": "Email Address",
      "quoteResult.enterEmail": "Enter your email",
      "quoteResult.sendQuote": "Send Quote",
      "quoteResult.sending": "Sending...",

      // Spec Categories
      "spec.structure": "Structure",
      "spec.insulation": "Insulation",
      "spec.electrical": "Electrical",
      "spec.plumbing": "Plumbing",
      "spec.interior": "Interior",
      "spec.kitchen": "Kitchen",
      "spec.bathroom": "Bathroom",
      "spec.hvac": "HVAC",
      "spec.exterior": "Exterior",
      "spec.smartHome": "Smart Home",

      // Common
      "common.sqft": "sq.ft",
      "common.sf": "sf",
      "common.bed": "bed",
      "common.bath": "bath",

      // Product Detail
      "productDetail.notFound": "Product not found",
      "productDetail.backHome": "Back to Home",
      "productDetail.backToModels": "Back to Models",
      "productDetail.generateQuote": "Generate Quote",
      "productDetail.getQuoteNow": "Get Quote Now",
      "productDetail.freeEstimate": "Free Estimate",
      "productDetail.sizeRange": "Available Size Range",
      "productDetail.description": "Description",
      "productDetail.highlights": "Highlights",
      "productDetail.openFloor": "Open-concept floor plan maximizes living space",
      "productDetail.fullKitchen": "Full-size kitchen with modern appliances",
      "productDetail.modernBath": "Modern bathroom with quality fixtures",
      "productDetail.energyEfficient": "Energy-efficient design with LED lighting",
      "productDetail.twoSeparateBeds": "Two separate bedrooms for privacy",
      "productDetail.sharedBath": "Shared full bathroom with tub/shower",
      "productDetail.idealRental": "Ideal layout for rental income",
      "productDetail.masterSuite": "Master suite with private bathroom",
      "productDetail.dualBath": "Dual full bathrooms for convenience",
      "productDetail.spaciousLiving": "Spacious open living and dining area",
      "productDetail.premiumFinish": "Premium finishes and upgraded materials",
      "productDetail.expandedLayout": "Expanded layout with enhanced storage",
      "productDetail.gourmetKitchen": "Gourmet kitchen with stone countertops",
      "productDetail.threeBedrooms": "Three bedrooms for maximum flexibility",
      "productDetail.familyLayout": "Family-friendly open layout design",
      "productDetail.maxSpace": "Maximum 1,200 sq.ft living space",
      "productDetail.1bedLong": "Our 1 Bedroom ADU is the perfect compact living solution. Featuring an open-concept design that maximizes every square foot, this unit includes a full-size kitchen with modern cabinetry, a spacious bedroom, and a well-appointed bathroom. Ideal for single occupants, home offices, or generating rental income. Standard features include LED lighting, vinyl plank flooring, and mini split AC system.",
      "productDetail.2bed1bathLong": "The 2 Bedroom 1 Bath ADU provides comfortable living for small families or roommates. With two separate bedrooms offering privacy and a shared full bathroom, this model strikes the perfect balance between space and efficiency. The open kitchen and living area create a welcoming common space, making it ideal for rental income or multigenerational living.",
      "productDetail.2bed2bathLong": "Our 2 Bed 2 Bath ADU delivers spacious living with the convenience of dual bathrooms. The master bedroom features its own private bathroom, while a second full bath serves the other bedroom and guests. The generous layout includes a full kitchen, open living area, and ample storage throughout.",
      "productDetail.2bed2bathDeluxeLong": "The 2 Bed 2 Bath Deluxe takes luxury living to the next level with an expanded layout and premium finishes. Featuring upgraded materials throughout — from European-style cabinetry to quartz countertops and premium vinyl flooring — this model offers a sophisticated living experience. Enhanced storage solutions and a gourmet kitchen complete the package.",
      "productDetail.3bedLong": "The 3 Bedroom ADU is designed for families who need maximum living space. With three separate bedrooms and two full bathrooms, this model provides comfort and privacy for everyone. The open-concept kitchen and living area offer generous space for family gatherings, while the thoughtful layout ensures efficient use of every square foot.",
      "productDetail.3bedPremiumLong": "Our largest and most luxurious model, the 3 Bed Premium represents the pinnacle of ADU living. At up to 1,200 sq.ft, this unit features premium finishes throughout — from upgraded flooring and cabinetry to designer lighting fixtures. The spacious master suite, gourmet kitchen with stone countertops, and expansive living area make this feel like a true luxury home."
    }
  },
  zh: {
    translation: {
      // Navigation
      "nav.models": "ADU 户型",
      "nav.packages": "ADU 套餐",
      "nav.howItWorks": "服务流程",
      "nav.portfolio": "项目案例",
      "nav.testimonials": "客户评价",
      "nav.faq": "常见问题",
      "nav.getQuote": "获取报价",
      "nav.login": "登录",

      // Hero
      "hero.title": "阿里建筑  打造您的梦想ADU",
      "hero.subtitle": "设计 · 审批 · 施工 · 交付一站式完成",
      "hero.freeEstimate": "免费估价",
      "hero.browseModels": "浏览户型",

      // Stats
      "stats.number1": "#1",
      "stats.number1": "#1",
      "stats.number1Sub": "30+年建商基因",
      "stats.number1Desc": "",
      "stats.fiveStar": "1500+套",
      "stats.fiveStarDesc": "ADU交付",
      "stats.floorPlans": "",
      "stats.floorPlansSub": "多个实体样板间开放",
      "stats.floorPlansDesc": "",

      // Models Section
      "models.title": "我们建造一至多卧室 ADU",
      "models.subtitle": "面积可达 1,200 平方英尺   自住投资海量案例可选",
      "models.learnMore": "了解更多",
      "models.getQuote": "获取报价",
      "models.browseAll": "浏览所有户型",
      "models.1bed": "一卧室 ADU",
      "models.1bedDesc": "适合单人居住或家庭办公",
      "models.2bed1bath": "两卧室 ADU",
      "models.2bed1bathDesc": "适合小家庭或出租创收",
      "models.2bed2bath": "两卧两卫 ADU",
      "models.2bed2bathDesc": "宽敞舒适，设施齐全",
      "models.2bed2bathDeluxe": "两卧两卫豪华版",
      "models.2bed2bathDeluxeDesc": "优化布局，高端装修",
      "models.3bed": "三卧室 ADU",
      "models.3bedDesc": "家庭最大空间选择",
      "models.3bedPremium": "三卧室尊享版",
      "models.3bedPremiumDesc": "最大面积，极致奢华",

      // ADU Packages Section
      "packages.title": "ADU 套餐方案",
      "packages.subtitlePlain": "比较我们四种标准套餐。所有套餐均包含优质建筑材料：JM 玻璃纤维隔热层、Dunn Edwards 涂料和 Cooper 管道。",
      "packages.viewFull": "查看完整套餐对比",
      "packages.popular": "热门",
      "packages.standard": "标准版",
      "packages.standardDesc": "优质建筑，基本配置齐全",
      "packages.premium": "高级版",
      "packages.premiumDesc": "升级材料，增强功能",
      "packages.luxury": "豪华版",
      "packages.luxuryDesc": "高端装修，豪华配置",
      "packages.smartLuxury": "智能豪华版",
      "packages.smartLuxuryDesc": "全屋智能家居系统",
      "packages.perSqft": "/平方英尺",
      "packages.8ftCeiling": "8英尺层高",
      "packages.9ftCeiling": "9英尺层高",
      "packages.9ftVaulted": "9英尺 + 穹顶",
      "packages.miniSplit": "分体式空调",
      "packages.centralAC": "中央空调",
      "packages.smartHome": "智能家居",
      "packages.standardFinishes": "标准装修",
      "packages.premiumFinishes": "高级装修",
      "packages.luxuryFinishes": "豪华装修",
      "packages.premiumEverything": "全面顶配",
      "packages.1yearWarranty": "1年质保",
      "packages.2yearWarranty": "2年质保",
      "packages.5yearWarranty": "5年质保",
      "packages.10yearWarranty": "10年质保",

      // How It Works
      "howItWorks.title": "ALIGCUS 服务流程",
      "howItWorks.subtitle": "从开始到完工的流畅体验",
      "howItWorks.step1Title": "免费估价",
      "howItWorks.step1Desc": "浏览我们的产品，向团队索取免费估价方案。",
      "howItWorks.step2Title": "可行性分析",
      "howItWorks.step2Desc": "对您的物业需求和当地法规进行深度分析，让您可以放心推进项目。",
      "howItWorks.step3Title": "设计与许可",
      "howItWorks.step3Desc": "ALIGCUS 帮您选择合适的布局和设计方案，并全程管理许可审批流程。",
      "howItWorks.step4Title": "施工与交付",
      "howItWorks.step4Desc": "以精湛工艺建造您的 ADU。我们准备地基，安装到位，确保入住就绪。",
      "howItWorks.getStarted": "立即获取免费估价",
      "howItWorks.learnMore": "了解更多服务流程",

      // Turnkey Services
      "turnkey.title": "一站式全包服务",
      "turnkey.subtitle": "从概念到竣工的全方位支持",
      "turnkey.design": "设计与规划",
      "turnkey.designDesc": "专业建筑设计，量身定制",
      "turnkey.projectManager": "专属项目经理",
      "turnkey.projectManagerDesc": "全程唯一对接人，沟通无障碍",
      "turnkey.feasibility": "可行性研究",
      "turnkey.feasibilityDesc": "全面的物业分析与评估",
      "turnkey.sitePrep": "场地准备",
      "turnkey.sitePrepDesc": "专业地基和基础施工",
      "turnkey.permitting": "许可服务",
      "turnkey.permittingDesc": "全程许可管理与审批",
      "turnkey.construction": "专业施工",
      "turnkey.constructionDesc": "行业领先标准的高品质建造",
      "turnkey.delivery": "交付与安装",
      "turnkey.deliveryDesc": "无缝交付与专业安装",
      "turnkey.financing": "融资资源",
      "turnkey.financingDesc": "对接可靠融资合作伙伴",
      "turnkey.warranty": "质保服务",
      "turnkey.warrantyDesc": "全面质保与持续售后",

      // Portfolio
      "portfolio.title": "每座城市都有我们的ADU故事",
      "portfolio.subtitle": "探索我们已完成的项目案例",
      "portfolio.featured": "精选项目",
      "portfolio.featuredTitle": "灵活住房解决方案",
      "portfolio.featuredSpec": "2卧 \u2022 2卫 \u2022 900平方英尺",
      "portfolio.featuredDesc": "精心打造的 ADU，最大化利用空间与功能，同时保持美学品味。非常适合出租创收或家庭扩展居住。",
      "portfolio.viewAll": "查看所有精选项目",

      // Comparison
      "comparison.title": "Pre-Approved 对比传统建造",
      "comparison.subtitle": "我们的预审批方案和流畅流程大幅缩短许可时间，加速您的 ADU 项目",
      "comparison.feature": "功能特点",
      "comparison.aligcus": "Pre-Approved",
      "comparison.traditional": "传统施工",
      "comparison.turnkey": "一站式全包服务",
      "comparison.preApproved": "多个城市政府预审批方案",
      "comparison.expedited": "加速方案审查和许可审批",
      "comparison.permittingTeam": "专属许可审批团队",
      "comparison.floorPlans": "预审批户型方案",
      "comparison.inspection": "简化验收流程",
      "comparison.projectManager": "专属项目经理",
      "comparison.timeOnSite": "现场施工时间",
      "comparison.aligcusTime": "约4-6个月",
      "comparison.traditionalTime": "约9-12个月以上",
      "comparison.pricing": "透明、预先定价",
      "comparison.financing": "融资合作伙伴",
      "comparison.experience": "体验 ALIGCUS 的不同",
      "comparison.cta": "立即获取免费估价",

      // FAQ
      "faq.title": "常见问题",
      "faq.subtitle": "了解关于我们 ADU 服务的常见问题解答",
      "faq.q1": "可以参观 ADU 样板房吗？",
      "faq.a1": "当然可以！欢迎预约参观我们已完成的项目。请致电 626-803-8000 预约。",
      "faq.q2": "ALIGCUS 建造哪些类型的 ADU？",
      "faq.a2": "ALIGCUS 建造面积从 500 到 1,200 平方英尺的独立式 ADU。这些 ADU 与主住宅分离，建在独立的永久地基上。我们的设计已获预审批，许可和验收流程更加高效。",
      "faq.q3": "如何知道我的物业是否适合建 ADU？",
      "faq.a3": "请致电 626-803-8000 联系我们团队，我们很乐意实时为您讲解各种方案！我们提供全面的可行性研究来评估您的物业。",
      "faq.q4": "你们提供融资方案吗？",
      "faq.a4": "虽然我们不是贷款机构，但我们可以为您对接专注于 ADU 融资的贷款合作伙伴。联系我们了解更多。",
      "faq.q5": "ALIGCUS 的 ADU 可以定制吗？",
      "faq.a5": "可以！ALIGCUS 顾问将为您介绍设计师精选的装修材料、布局调整等定制选项。",
      "faq.q6": "有哪些户型方案？",
      "faq.a6": "我们提供 1、2、3 卧室户型，面积从 500 到 1,200 平方英尺。每种户型都可根据您的需求定制。",
      "faq.q7": "ALIGCUS 负责办理许可吗？",
      "faq.a7": "是的，我们专业团队全程办理许可！我们在洛杉矶地区拥有丰富的许可办理经验，与各地许可部门建立了高效的合作关系。",
      "faq.q8": "施工需要多长时间？",
      "faq.a8": "我们的高效流程通常现场施工仅需 4-6 个月，远快于传统施工的 9-12 个月以上。从设计到竣工的总时间取决于许可审批和场地条件。",
      "faq.q9": "一站式服务包含哪些内容？",
      "faq.a9": "我们的全包服务涵盖设计规划、可行性研究、许可办理、场地准备、施工建造、交付安装、管线连接和质保服务。从头到尾，一手包办。",
      "faq.q10": "ADU 可以用来出租吗？",
      "faq.a10": "当然可以！很多客户建造 ADU 就是为了出租创收。ADU 是绝佳的投资机会，我们可以帮您分析潜在投资回报。",
      "faq.stillQuestions": "还有其他问题？",
      "faq.helpText": "我们的团队随时为您提供帮助",
      "faq.contactUs": "立即联系我们",

      // Testimonials
      "testimonials.title": "客户真实评价",
      "testimonials.subtitle": "深受洛杉矶业主信赖",
      "testimonials.projects": "已完成项目",
      "testimonials.satisfaction": "客户满意度",
      "testimonials.rating": "平均评分",

      // Footer
      "footer.description": "专注于建筑设计、施工和 ADU 开发的综合房地产公司。",
      "footer.serving": "自豪地服务于整个加州",
      "footer.quickLinks": "快速链接",
      "footer.socalOffice": "南加州办公室",
      "footer.norcalOffice": "北加州办公室",
      "footer.rights": "版权所有",
      "footer.privacy": "隐私政策",
      "footer.terms": "服务条款",
      "footer.cookies": "Cookie 政策",

      // Quote Calculator
      "quote.quickQuote": "快速报价",
      "quote.getInstantEstimate": "即时获取您的 ADU 项目估价",
      "quote.projectAddress": "1. 项目地址",
      "quote.startTyping": "开始输入地址...",
      "quote.satelliteView": "物业位置（卫星视图）",
      "quote.selectPackage": "2. 选择套餐",
      "quote.rooms": "3. 房间配置",
      "quote.bedrooms": "卧室",
      "quote.bathrooms": "卫浴",
      "quote.squareFootage": "4. 建筑面积",
      "quote.size": "面积",
      "quote.recommendedFor": "推荐 {{beds}}卧/{{baths}}卫: {{range}}",
      "quote.surchargeNote": "800 平方英尺以下实行阶梯单价：面积每减少 100 平方英尺，单价增加 $20/平方英尺（不足 100 平方英尺按一档计算）",
      "quote.upgrades": "5. 升级选项",
      "quote.optional": "（可选）",
      "quote.addCustomItem": "添加自定义项目",
      "quote.itemName": "项目名称",
      "quote.price": "价格",
      "quote.generateQuote": "生成报价",
      "quote.generating": "生成中...",
      "quote.estimatedTotal": "预估总价",
      "quote.enterInfo": "请输入地址，选择套餐和面积来生成报价",
      "quote.base": "基础价格",
      "quote.smallUnitSurcharge": "小户型附加费",
      "quote.upgradesLabel": "升级项目",
      "quote.customItems": "自定义项目",
      "quote.backToHome": "返回首页",

      // Quote Result
      "quoteResult.aduQuote": "ADU 报价单",
      "quoteResult.projectLocation": "项目地址",
      "quoteResult.package": "套餐",
      "quoteResult.sizeLabel": "面积",
      "quoteResult.layout": "户型",
      "quoteResult.ceiling": "层高",
      "quoteResult.priceSummary": "价格明细",
      "quoteResult.totalEstimate": "预估总价",
      "quoteResult.notes": "备注：",
      "quoteResult.note1": "仅为估价，最终价格因场地条件而异。",
      "quoteResult.note2": "不含许可费、管线连接费、场地准备费。",
      "quoteResult.note3": "报价有效期 30 天。",
      "quoteResult.specs": "套餐规格明细",
      "quoteResult.downloadPdf": "下载 PDF",
      "quoteResult.exporting": "导出中...",
      "quoteResult.email": "发送邮件",
      "quoteResult.print": "打印",
      "quoteResult.newQuote": "重新报价",
      "quoteResult.sendEmail": "通过邮件发送报价",
      "quoteResult.yourName": "您的姓名",
      "quoteResult.enterName": "请输入姓名",
      "quoteResult.emailAddress": "邮箱地址",
      "quoteResult.enterEmail": "请输入邮箱",
      "quoteResult.sendQuote": "发送报价",
      "quoteResult.sending": "发送中...",

      // Spec Categories
      "spec.structure": "结构",
      "spec.insulation": "隔热",
      "spec.electrical": "电气",
      "spec.plumbing": "管道",
      "spec.interior": "室内",
      "spec.kitchen": "厨房",
      "spec.bathroom": "卫浴",
      "spec.hvac": "暖通空调",
      "spec.exterior": "外部",
      "spec.smartHome": "智能家居",

      // Common
      "common.sqft": "平方英尺",
      "common.sf": "平方英尺",
      "common.bed": "卧",
      "common.bath": "卫",

      // Product Detail
      "productDetail.notFound": "未找到该产品",
      "productDetail.backHome": "返回首页",
      "productDetail.backToModels": "返回户型列表",
      "productDetail.generateQuote": "生成报价",
      "productDetail.getQuoteNow": "立即获取报价",
      "productDetail.freeEstimate": "免费估价",
      "productDetail.sizeRange": "可选面积范围",
      "productDetail.description": "产品介绍",
      "productDetail.highlights": "产品亮点",
      "productDetail.openFloor": "开放式户型设计，最大化利用居住空间",
      "productDetail.fullKitchen": "配备现代化电器的全尺寸厨房",
      "productDetail.modernBath": "现代化浴室，优质卫浴设施",
      "productDetail.energyEfficient": "节能设计，全屋LED照明",
      "productDetail.twoSeparateBeds": "两间独立卧室，保障隐私",
      "productDetail.sharedBath": "共享全功能浴室，配浴缸/淋浴",
      "productDetail.idealRental": "理想的出租创收户型",
      "productDetail.masterSuite": "主卧套房配独立卫浴",
      "productDetail.dualBath": "双卫浴设计，使用更便捷",
      "productDetail.spaciousLiving": "宽敞的开放式客厅和餐厅",
      "productDetail.premiumFinish": "高端装修材料和升级配置",
      "productDetail.expandedLayout": "加大户型，增强储物空间",
      "productDetail.gourmetKitchen": "豪华厨房配石英石台面",
      "productDetail.threeBedrooms": "三间卧室，灵活空间组合",
      "productDetail.familyLayout": "家庭友好型开放式布局",
      "productDetail.maxSpace": "最大1,200平方英尺居住空间",
      "productDetail.1bedLong": "我们的一卧室ADU是完美的紧凑型居住方案。采用开放式设计，最大化利用每一平方英尺的空间。配备全尺寸厨房、现代橱柜、宽敞卧室和精致浴室。适合单人居住、家庭办公或出租创收。标准配置包括LED照明、乙烯基地板和迷你分体空调系统。",
      "productDetail.2bed1bathLong": "两卧一卫ADU为小家庭或合租提供舒适的居住空间。两间独立卧室保障隐私，共享一间全功能浴室。开放式厨房和客厅营造温馨的公共空间，非常适合出租创收或多代同堂居住。",
      "productDetail.2bed2bathLong": "我们的两卧两卫ADU提供宽敞的居住空间和双卫浴的便利。主卧配备独立卫浴，另一间全功能浴室服务于次卧和客人。宽敞的户型包含全尺寸厨房、开放式客厅和充足的储物空间。",
      "productDetail.2bed2bathDeluxeLong": "两卧两卫豪华版将奢华生活提升至新高度，采用加大户型和高端装修。全屋升级材料——从欧式橱柜到石英石台面，再到高级乙烯基地板——提供精致的居住体验。增强的储物方案和豪华厨房使其更加完美。",
      "productDetail.3bedLong": "三卧室ADU专为需要最大居住空间的家庭设计。三间独立卧室和两间全功能浴室，为每位家庭成员提供舒适和隐私。开放式厨房和客厅为家庭聚会提供充足空间，合理的布局确保每一平方英尺的高效利用。",
      "productDetail.3bedPremiumLong": "三卧室尊享版是我们最大、最豪华的户型，代表ADU居住的巅峰之作。面积可达1,200平方英尺，全屋高端装修——从升级地板和橱柜到设计师灯具。宽敞的主卧套房、配石英石台面的豪华厨房和大面积客厅，让它成为真正的豪华住宅。"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('aligcus_lang') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
